// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { TimestampsToReturn } from "./timestamps-to-return";

/**
 * Session and secure-channel tuning parameters.
 */
export class SessionConfig implements flatbuffers.IUnpackableObject<SessionConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SessionConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSessionConfig(bb: flatbuffers.ByteBuffer, obj?: SessionConfig): SessionConfig {
    return (obj || new SessionConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSessionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionConfig,
  ): SessionConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SessionConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Requested session timeout in milliseconds.
   */
  sessionTimeoutMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 60000.0;
  }

  /**
   * Secure channel token lifetime in milliseconds.
   */
  secureChannelLifetimeMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 600000;
  }

  /**
   * Per-request timeout in milliseconds.
   */
  requestTimeoutMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 10000;
  }

  /**
   * Keep-alive (publish) interval in milliseconds.
   */
  keepAliveIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 10000;
  }

  /**
   * Number of reconnect attempts before giving up (-1 = unlimited).
   */
  sessionRetryLimit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 10;
  }

  /**
   * Delay between reconnect attempts in milliseconds.
   */
  sessionRetryIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 5000;
  }

  /**
   * Preferred locale ids for DisplayName / LocalizedText, in priority order.
   */
  preferredLocales(index: number): string;
  preferredLocales(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  preferredLocales(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  preferredLocalesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Max chunk count for a single message (0 = server default).
   */
  maxChunkCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Max message size in bytes (0 = server default).
   */
  maxMessageSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Timestamps the server should return on reads / notifications.
   */
  timestampsToReturn(): TimestampsToReturn {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TimestampsToReturn.Both;
  }

  static startSessionConfig(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addSessionTimeoutMs(builder: flatbuffers.Builder, sessionTimeoutMs: number) {
    builder.addFieldFloat64(0, sessionTimeoutMs, 60000.0);
  }

  static addSecureChannelLifetimeMs(builder: flatbuffers.Builder, secureChannelLifetimeMs: number) {
    builder.addFieldInt32(1, secureChannelLifetimeMs, 600000);
  }

  static addRequestTimeoutMs(builder: flatbuffers.Builder, requestTimeoutMs: number) {
    builder.addFieldInt32(2, requestTimeoutMs, 10000);
  }

  static addKeepAliveIntervalMs(builder: flatbuffers.Builder, keepAliveIntervalMs: number) {
    builder.addFieldInt32(3, keepAliveIntervalMs, 10000);
  }

  static addSessionRetryLimit(builder: flatbuffers.Builder, sessionRetryLimit: number) {
    builder.addFieldInt32(4, sessionRetryLimit, 10);
  }

  static addSessionRetryIntervalMs(builder: flatbuffers.Builder, sessionRetryIntervalMs: number) {
    builder.addFieldInt32(5, sessionRetryIntervalMs, 5000);
  }

  static addPreferredLocales(
    builder: flatbuffers.Builder,
    preferredLocalesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, preferredLocalesOffset, 0);
  }

  static createPreferredLocalesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startPreferredLocalesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMaxChunkCount(builder: flatbuffers.Builder, maxChunkCount: number) {
    builder.addFieldInt32(7, maxChunkCount, 0);
  }

  static addMaxMessageSize(builder: flatbuffers.Builder, maxMessageSize: number) {
    builder.addFieldInt32(8, maxMessageSize, 0);
  }

  static addTimestampsToReturn(
    builder: flatbuffers.Builder,
    timestampsToReturn: TimestampsToReturn,
  ) {
    builder.addFieldInt8(9, timestampsToReturn, TimestampsToReturn.Both);
  }

  static endSessionConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSessionConfig(
    builder: flatbuffers.Builder,
    sessionTimeoutMs: number,
    secureChannelLifetimeMs: number,
    requestTimeoutMs: number,
    keepAliveIntervalMs: number,
    sessionRetryLimit: number,
    sessionRetryIntervalMs: number,
    preferredLocalesOffset: flatbuffers.Offset,
    maxChunkCount: number,
    maxMessageSize: number,
    timestampsToReturn: TimestampsToReturn,
  ): flatbuffers.Offset {
    SessionConfig.startSessionConfig(builder);
    SessionConfig.addSessionTimeoutMs(builder, sessionTimeoutMs);
    SessionConfig.addSecureChannelLifetimeMs(builder, secureChannelLifetimeMs);
    SessionConfig.addRequestTimeoutMs(builder, requestTimeoutMs);
    SessionConfig.addKeepAliveIntervalMs(builder, keepAliveIntervalMs);
    SessionConfig.addSessionRetryLimit(builder, sessionRetryLimit);
    SessionConfig.addSessionRetryIntervalMs(builder, sessionRetryIntervalMs);
    SessionConfig.addPreferredLocales(builder, preferredLocalesOffset);
    SessionConfig.addMaxChunkCount(builder, maxChunkCount);
    SessionConfig.addMaxMessageSize(builder, maxMessageSize);
    SessionConfig.addTimestampsToReturn(builder, timestampsToReturn);
    return SessionConfig.endSessionConfig(builder);
  }

  unpack(): SessionConfigT {
    return new SessionConfigT(
      this.sessionTimeoutMs(),
      this.secureChannelLifetimeMs(),
      this.requestTimeoutMs(),
      this.keepAliveIntervalMs(),
      this.sessionRetryLimit(),
      this.sessionRetryIntervalMs(),
      this.bb!.createScalarList<string>(
        this.preferredLocales.bind(this),
        this.preferredLocalesLength(),
      ),
      this.maxChunkCount(),
      this.maxMessageSize(),
      this.timestampsToReturn(),
    );
  }

  unpackTo(_o: SessionConfigT): void {
    _o.sessionTimeoutMs = this.sessionTimeoutMs();
    _o.secureChannelLifetimeMs = this.secureChannelLifetimeMs();
    _o.requestTimeoutMs = this.requestTimeoutMs();
    _o.keepAliveIntervalMs = this.keepAliveIntervalMs();
    _o.sessionRetryLimit = this.sessionRetryLimit();
    _o.sessionRetryIntervalMs = this.sessionRetryIntervalMs();
    _o.preferredLocales = this.bb!.createScalarList<string>(
      this.preferredLocales.bind(this),
      this.preferredLocalesLength(),
    );
    _o.maxChunkCount = this.maxChunkCount();
    _o.maxMessageSize = this.maxMessageSize();
    _o.timestampsToReturn = this.timestampsToReturn();
  }

  unpackFields(...fields: string[]): SessionConfigT {
    const t = new SessionConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("session_timeout_ms")) {
      t.sessionTimeoutMs = this.sessionTimeoutMs();
    }
    if (fieldSet.has("secure_channel_lifetime_ms")) {
      t.secureChannelLifetimeMs = this.secureChannelLifetimeMs();
    }
    if (fieldSet.has("request_timeout_ms")) {
      t.requestTimeoutMs = this.requestTimeoutMs();
    }
    if (fieldSet.has("keep_alive_interval_ms")) {
      t.keepAliveIntervalMs = this.keepAliveIntervalMs();
    }
    if (fieldSet.has("session_retry_limit")) {
      t.sessionRetryLimit = this.sessionRetryLimit();
    }
    if (fieldSet.has("session_retry_interval_ms")) {
      t.sessionRetryIntervalMs = this.sessionRetryIntervalMs();
    }
    if (fieldSet.has("preferred_locales")) {
      t.preferredLocales = this.bb!.createScalarList<string>(
        this.preferredLocales.bind(this),
        this.preferredLocalesLength(),
      );
    }
    if (fieldSet.has("max_chunk_count")) {
      t.maxChunkCount = this.maxChunkCount();
    }
    if (fieldSet.has("max_message_size")) {
      t.maxMessageSize = this.maxMessageSize();
    }
    if (fieldSet.has("timestamps_to_return")) {
      t.timestampsToReturn = this.timestampsToReturn();
    }
    return t;
  }
}

export class SessionConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public sessionTimeoutMs: number = 60000.0,
    public secureChannelLifetimeMs: number = 600000,
    public requestTimeoutMs: number = 10000,
    public keepAliveIntervalMs: number = 10000,
    public sessionRetryLimit: number = 10,
    public sessionRetryIntervalMs: number = 5000,
    public preferredLocales: string[] = [],
    public maxChunkCount: number = 0,
    public maxMessageSize: number = 0,
    public timestampsToReturn: TimestampsToReturn = TimestampsToReturn.Both,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const preferredLocales = SessionConfig.createPreferredLocalesVector(
      builder,
      builder.createObjectOffsetList(this.preferredLocales),
    );

    return SessionConfig.createSessionConfig(
      builder,
      this.sessionTimeoutMs,
      this.secureChannelLifetimeMs,
      this.requestTimeoutMs,
      this.keepAliveIntervalMs,
      this.sessionRetryLimit,
      this.sessionRetryIntervalMs,
      preferredLocales,
      this.maxChunkCount,
      this.maxMessageSize,
      this.timestampsToReturn,
    );
  }

  clone(): SessionConfigT {
    const obj = new SessionConfigT();
    obj.sessionTimeoutMs = this.sessionTimeoutMs;
    obj.secureChannelLifetimeMs = this.secureChannelLifetimeMs;
    obj.requestTimeoutMs = this.requestTimeoutMs;
    obj.keepAliveIntervalMs = this.keepAliveIntervalMs;
    obj.sessionRetryLimit = this.sessionRetryLimit;
    obj.sessionRetryIntervalMs = this.sessionRetryIntervalMs;
    obj.preferredLocales = [...this.preferredLocales];
    obj.maxChunkCount = this.maxChunkCount;
    obj.maxMessageSize = this.maxMessageSize;
    obj.timestampsToReturn = this.timestampsToReturn;
    return obj;
  }

  equals(other: SessionConfigT): boolean {
    if (!Object.is(this.sessionTimeoutMs, other.sessionTimeoutMs)) return false;
    if (this.secureChannelLifetimeMs !== other.secureChannelLifetimeMs) return false;
    if (this.requestTimeoutMs !== other.requestTimeoutMs) return false;
    if (this.keepAliveIntervalMs !== other.keepAliveIntervalMs) return false;
    if (this.sessionRetryLimit !== other.sessionRetryLimit) return false;
    if (this.sessionRetryIntervalMs !== other.sessionRetryIntervalMs) return false;
    if (this.preferredLocales.length !== other.preferredLocales.length) return false;
    for (let i = 0; i < this.preferredLocales.length; i++) {
      if (this.preferredLocales[i] !== other.preferredLocales[i]) return false;
    }
    if (this.maxChunkCount !== other.maxChunkCount) return false;
    if (this.maxMessageSize !== other.maxMessageSize) return false;
    if (this.timestampsToReturn !== other.timestampsToReturn) return false;
    return true;
  }
}

export function verifySessionConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 1);
  } finally {
    verifier.popDepth();
  }
}
